/* eslint-disable import/prefer-default-export */
export const onEnter = (f: () => void) => (e: { keyCode: number }) =>
  e.keyCode === 13 && f()

export const isPropEqTo = (
  object: { props: any },
  prop: string,
  context: any
) => object.props[prop] === context

export const BreakPoint: {
  [key: string]: number
} = {
  small: 420,
  medium: 768,
  large: 1024,
}

export const getBreakpoint = (pixels: number): keyof typeof BreakPoint => {
  return Object.keys(BreakPoint).reduce(breakpoint =>
    pixels >= BreakPoint[breakpoint] ? breakpoint : "large"
  )
}

export type BreakPointType = keyof typeof BreakPoint

export const isMobile = (window: Window) =>
  BreakPoint.small >= window.innerWidth
export const isTablet = (window: Window) =>
  BreakPoint.medium >= window.innerWidth

export const isMidDesktop = (window: Window) =>
  BreakPoint.large >= window.innerWidth

export const makeAbsoluteUrl = (
  path: string,
  shouldAddSlash: boolean = true,
  nestedRouteString?: string
) =>
  `${process.env.GATSBY_DOMAIN_URL}${nestedRouteString ?? ""}${
    shouldAddSlash ? "/" : ""
  }${path}`
